import { combineReducers, type UnknownAction } from '@reduxjs/toolkit';

import { replaceVehicleValue } from 'Core/actions/fitmentSearch/index';
import { createIsolatedReducer } from 'Core/reducers/common';
import fields from 'Core/reducers/fitmentSearch/fields';

import { fixRequestDueToResponse } from '../common';
import isolatedKey from './isolatedKey';
import request from './request';
import response from './response';

const baseIsolatedDialog = createIsolatedReducer(
  isolatedKey,
  combineReducers({
    request,
    response,
    fields,
  }),
);

type IsolatedDialogState = ReturnType<typeof baseIsolatedDialog>;

const isolatedDialog = (state: IsolatedDialogState | undefined, action: UnknownAction): IsolatedDialogState =>
  baseIsolatedDialog(fixRequestDueToResponse(state, replaceVehicleValue.match(action)), action);

export default isolatedDialog;
